import {routes} from "@/router/routes";


export default {
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return {x: 0, y: 0};
    },
    routes
};